<div class="bar-wrapper">
      <ng-content></ng-content>
   <div class="close-bar" (click)="closeBar()"><img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/svg-icons/close-bar-icon.svg" height="11px" width="11px" alt=""></div>
</div>